import { api } from "../app/api.js";
import { store } from "../app/store.js";

export function checkKetvStatus () {
    api.get({
        url: '/ketv/status',
        cache_ttl: false,
        retry: false,
        success: (response) => {
            store.set('ketv', response);
        },
        error: () => {
            store.set('ketv', {
                online: false,
            });
        },
        complete: () => {
            setTimeout(checkKetvStatus, 10000);
        }
    })
}
